import React from 'react';
import { Box } from '../../UI';
import StatusSelect from '../../UI/StatusSelect';
import DateSelect from '../../UI/DateSelect';
import { Typography } from '@material-ui/core';

export default function Meta() {

	return (
		<Box>
			<Typography variant='h5'><strong>Process Setting</strong></Typography>
			<Box display='flex' justifyContent='space-between' mt='1rem'> 
				<StatusSelect
					label='Status'
					variant="standard"
					style={{width: '30%'}}
				/>
				<DateSelect style={{width: '30%'}} />
				<Box style={{width: '30%'}} display='flex' flexDirection='column' alignItems='flex-end'>
					<Typography variant='body1'>Date Launched: 10/05/2020</Typography>
					<Typography variant='body1' color='textSecondary'>Days Remaining: 8</Typography>
				</Box>
			</Box>
		</Box>
	);
}
